import { useEffect, useState } from "react";
import { makeRequest } from "../apis/makeRequest";
import { getAlicuota, getCustomer } from "../apis/backendRequests";

const useTotals = (items, dynamicsId, totalDesc) => {
  const [customer, setCustomer] = useState(null);
  const [alicuota, setAlicuota] = useState(0);

  useEffect(() => {
    if (!dynamicsId) return;

    makeRequest(
      () => getCustomer(dynamicsId),
      (res) => setCustomer(res.data),
      null,
      { checkEmptyResults: false }
    );
    makeRequest(
      () => getAlicuota(dynamicsId),
      (res) => setAlicuota(res.data.alicuota)
    );
  }, [dynamicsId]);

  if (!totalDesc) {
    return {
      subtotal: 0,
      discount: 0,
      tax: 0,
      total: 0,
    };
  }

  const descuentosPorId = totalDesc?.reduce((obj, descuento) => {
    obj[descuento.productId] = descuento.desc;
    return obj;
  }, {});

  const subtotal = items?.reduce((total, producto) => {
    const { productId, quantity, unitPrice } = producto;
    const descuento = descuentosPorId[productId];

    if (descuento !== undefined) {
      if (descuento === 0) {
        const precioConDescuento = unitPrice;
        const subtotal = precioConDescuento * quantity;
        total += subtotal;
      } else {
        const precioConDescuento = unitPrice * (1 - descuento / 100);
        const subtotal = precioConDescuento * quantity;
        total += subtotal;
      }
    }

    return total;
  }, 0);

  const discount = parseFloat(
    ((subtotal * customer?.descuentoComercial) / 100).toFixed(2)
  );
  const tax = parseFloat(
    ((subtotal - discount) * (alicuota / 100)).toFixed(2)
  );
  const total = parseFloat((subtotal - discount + tax).toFixed(2));
  return { subtotal, discount, tax, total, descuentoComercial: customer?.descuentoComercial };
};

export default useTotals;
